var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-radio",class:[{'z-chk': _vm.checkState}, ("s-" + _vm.skin)],on:{"click":function($event){return _vm.checkHandle(true)}}},[_c('div'),(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }